import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { APP_PATHS } from 'src/app/app.paths';
import { AuthService } from '@app/services/auth.service';

@Component({
  selector: 'lgv-logout',
  template: '',
  standalone: false,
})
export class LogoutComponent implements OnInit {
  private auth = inject(AuthService);
  private router = inject(Router);

  ngOnInit(): void {
    this.auth.logout();
    this.router.navigateByUrl(APP_PATHS.ROOT);
  }
}
